<template>
  <div class="business">
    <div class="top-bar">
      <span @click="cancel">
        <i class="left"></i>
      </span>
      <span class="heading_new">Advance Settings</span>
      <span class="spacer" />
    </div>

    <div class="main-container">
      <div class="custom-grid margin-top-10">
        <tl-select
          label="Component"
          labelText="name"
          :name="'components'"
          :options="componentsList"
          v-model="assignedComponentsObj.componentObj"
          @change="componentChanged($event)"
        />
      </div>
      <div class="custom-grid margin-top-10">
        <div>
          <span class="input-label">Start Date</span>
          <date-picker
            label="Applicable From"
            class="ht-35 margin-top-5"
            :name="'applicableFrom'"
            @datevalue="fromDateChanged($event)"
            :value="assignedComponentsObj.applicableFrom_date"
            v-model="assignedComponentsObj.applicableFrom_date"
            :formatDate="'dd-MM-yyyy'"
            :classname="errors.has('applicableFrom')"
            v-validate="'applicableFrom'"
            :errormsg="errors.first('applicableFrom')"
            @dateChanged="dateChange($event)"
          />
          <!-- @datevalue="(val)=>assignedComponentsObj.applicableFrom_date=val" -->
        </div>
        <div>
          <span class="input-label">Start Date</span>
          <date-picker
            label="Applicable To"
            class="ht-35 margin-top-5"
            :name="'applicableTo'"
            @datevalue="toDateChanged($event)"
            :value="assignedComponentsObj.applicableTo_date"
            v-model="assignedComponentsObj.applicableTo_date"
            :formatDate="'dd-MM-yyyy'"
            :classname="errors.has('applicableTo')"
            v-validate="'applicableTo'"
            :errormsg="errors.first('applicableTo')"
          />
          <!-- @datevalue="(val)=>assignedComponentsObj.applicableTo_date=val" -->
        </div>
      </div>

      <div class="datatable-outer-container margin-top-30">
        <table class="datatable">
          <thead>
            <tr class="header-row">
              <th>S.no</th>
              <th>Schedule Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <!-- </tr> -->
          <tr class="record-row" v-for="(item, index) in monthsArray" :key="index">
            <td>
              <p>{{index+1}}</p>
            </td>
            <td>
              <p>{{item.scheduleDate}}</p>
            </td>
            <td>
              <input
                type="number"
                class="inputbox custom-input"
                :name="'amount'+index"
                v-model="item.amount"
              />
            </td>
          </tr>
        </table>
      </div>

      <footer>
        <bottom-action-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="save"></btn>
            </btn-grp>
          </template>
        </bottom-action-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      employeeObject: {},
      selectedComponentIndex: null,
      componentsList: [],
      assignedComponentsObj: {
        componentObj: null,
        applicable_from: null,
        applicable_to: null,
        advanced_setting: null,
        amount: null,
        name: null,
        salary_component_id: null,
        unassign_date: null
      },

      historyObj: {
        fromMonth: null,
        fromYear: null,
        toMonth: null,
        toYear: null
      },

      monthsArray: [],
      assignedMonthsArray: [],
      componentObj: {},

      assignedComponentsList: []
    };
  },

  computed: {
    ...mapState({
      orgData: state => state.onboard.organization.state.data[0],
      getRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.record,
      getComponentSelectedRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.data[
          state.dashboard.payroll.utilities.assignFixedNonCTCcomponents
            .selectedEmployeeIndex
        ].EmployeeNonCTCComponent.salary_component[
          state.dashboard.payroll.utilities.assignFixedNonCTCcomponents
            .selectedComponentIndex
        ],
      getComponentRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.nonCtcComponentRecord,

    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
      // getRecord: "dashboard/payroll/utilities/assignFixedNonCTCcomponents/record"
    }),

    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    }
  },

  activated() {
    let encodedStr = this.getComponentEncryptedString();
    var decodedString = encodedStr;
    this.selectedComponentIndex = decodedString;

    this.employeeObject = this.getRecord;
    //console.log("employeeObject:", this.employeeObject);
    //console.log("getComponentSelectedRecord:", this.getComponentSelectedRecord);
    //console.log("getComponentRecord:", this.getComponentRecord);

    this.assignedComponentsList = [];

    this.getLegalEntitySalaryComponents();

    this.monthsArray = [];

    // debugger
    // this.componentObj = this.getComponentRecord;
    // this.assignedComponentsObj = this.componentObj;
    // this.monthsArray = this.componentObj.advanced_setting ? this.componentObj.advanced_setting : [];

    if (this.employeeObject.EmployeeNonCTCComponent) {
      if (this.employeeObject.EmployeeNonCTCComponent.salary_component) {
        if (
          this.employeeObject.EmployeeNonCTCComponent.salary_component.length
        ) {
          this.employeeObject.EmployeeNonCTCComponent.salary_component.forEach(
            (element, index) => {
              let obj = {
                id: element.salary_component_id,
                applicableFrom_date: element.applicable_from,
                applicableTo_date: element.applicable_to,
                amount: element.amount,
                showDropDown: false,
                isEditable: false,
                name: element.name,
                advanced_setting: element.advanced_setting
              };
              this.assignedComponentsList.push(element);
              if (index == this.selectedComponentIndex) {
                this.componentObj = obj;
                this.assignedComponentsObj = this.componentObj;
                //this.monthsArray = element.advanced_setting;
              }
            }
          );
        }
      }
    }

    this.assignedMonthsArray = this.componentObj.advanced_setting ? this.componentObj.advanced_setting : [];
    this.monthsArray = this.componentObj.advanced_setting ? this.componentObj.advanced_setting : [];
    //console.log("activated monthsArray:", this.monthsArray);

  },

  methods: {
    ...mapActions({
      fetchNonCtcComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/fetchNonCtcComponents",
      assignNonCtcComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/update",
      updateNonCtcComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/updateNonCtcComponents",
      fetchLegalEntitySalaryComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/fetchLegalEntitySalaryComponents",
      act_updateRecordsComponentsAdvancedSettings:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/updateRecordsComponentsAdvancedSettings"
    }),

    dateChange(event){
      //console.log('dateChange:',event);
    },

    componentChanged(event) {
      //console.log("componentChanged:", event);

      if (event) {
        this.assignedComponentsObj.id = event.salary_component_id;
        this.assignedComponentsObj.name = event.name;
      }
    },

    getStatus(salaryComponentObj){

      let currentDate = new Date();
      let applicable_from = new Date(salaryComponentObj.applicableFrom_date) ;
      let applicable_to = new Date(salaryComponentObj.applicableTill_date) ;


      if (salaryComponentObj.unassign_date){
        return "Unassigned";
      }else if (currentDate < applicable_from){
        return "Scheduled";
      }else if (currentDate > applicable_from && currentDate < applicable_to){
        return "Active";
      }else{
        return "Completed";
      }

    },

    async getLegalEntitySalaryComponents() {
      try {
        let res = await this.fetchLegalEntitySalaryComponents(this.le_id);
        //console.log("getLegalEntitySalaryComponents:", res);

        if (res.status == 200 || res.status == 201) {
          this.componentsList = res.data.payload.data;

          if (this.employeeObject.EmployeeNonCTCComponent) {
            if (this.employeeObject.EmployeeNonCTCComponent.salary_component) {
              if (
                this.employeeObject.EmployeeNonCTCComponent.salary_component
                  .length
              ) {
                this.employeeObject.EmployeeNonCTCComponent.salary_component.forEach(
                  (element, index) => {
                    if (index == this.selectedComponentIndex) {
                      this.setSalaryComponetsData(element);
                    }
                  }
                );

                // //console.log(
                //   "assignedComponentsList:",
                //   this.assignedComponentsList
                // );
              }
            }
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        //console.log("error:", err);
      }
    },

    setSalaryComponetsData(element) {
      this.assignedComponentsObj.componentObj = element;
    },

    getComponentEncryptedString() {
      return this.$route.query.componentIndex;
    },

    fromDateChanged(event) {
      var splitted = event.split("-");
      //console.log("splitted:", splitted);

      if (splitted.length) {
        this.historyObj.fromYear = splitted[0];
        this.historyObj.fromMonth = splitted[1];

        if (this.historyObj.fromYear) {
        }
      }

      this.assignedComponentsObj.applicableFrom_date = event;

      this.dateRange(
        this.assignedComponentsObj.applicableFrom_date,
        this.assignedComponentsObj.applicableTo_date
      );
    },

    toDateChanged(event) {
      var splitted = event.split("-");
      //console.log("toDateChanged:", event);

      if (splitted.length) {
        this.historyObj.toMonth = splitted[0];
        this.historyObj.toYear = splitted[1];

        if (this.historyObj.toYear) {
        }
      }

      this.assignedComponentsObj.applicableTo_date = event;

      this.dateRange(
        this.assignedComponentsObj.applicableFrom_date,
        this.assignedComponentsObj.applicableTo_date
      );
    },

    dateRange(startDate, endDate) {
      if (startDate && endDate) {
        var start = startDate.split("-");
        var end = endDate.split("-");
        var startYear = parseInt(start[0]);
        var endYear = parseInt(end[0]);
        this.monthsArray = [];

        for (var i = startYear; i <= endYear; i++) {
          var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
          var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
          for (
            var j = startMon;
            j <= endMonth;
            j = j > 12 ? j % 12 || 11 : j + 1
          ) {
            var month = j + 1;
            var displayMonth = month < 10 ? "0" + month : month;
            let finalMonth = this.getMonthName(String(displayMonth));

            let existedObj =  this.assignedMonthsArray.find(item => item.scheduleDate == [finalMonth, i].join(" "));

            let obj = {
              amount: existedObj ? existedObj.amount: '',
              scheduleDate: [finalMonth, i].join(" ")
            };

            this.monthsArray.push(obj);
          }
        }
        //console.log("dateRange monthsArray:", this.monthsArray);
      }
    },

    getMonthName(monthId) {
      switch (monthId) {
        case "01":
          return "January";
          break;
        case "02":
          return "February";
          break;
        case "03":
          return "March";
          break;
        case "04":
          return "April";
          break;
        case "05":
          return "May";
          break;
        case "06":
          return "June";
          break;
        case "07":
          return "July";
          break;
        case "08":
          return "August";
          break;
        case "09":
          return "September";
          break;
        case "10":
          return "October";
          break;
        case "11":
          return "November";
          break;
        case "12":
          return "December";
          break;
        default:
          return "";
      }
    },

    cancel() {
      this.refresh();
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assignFixedNonCtcComponents`
      // });
      this.$router.go(-1);
    },

    save() {
      // this.$validator.validateAll().then(result => {
      //   if (result) {
      //     this.toast = false;
      //     this.errmsg = "";

      this.performAction();
      //   } else {
      //     this.toast = true;
      //     this.errmsg = "Please fill mandatory fields!";
      //   }
      // });
    },

    async performAction() {

      let addedComponentsArr = this.assignedComponentsList;
      let finalArr = [];

      for (let i = 0; i < addedComponentsArr.length; i++) {
        if (this.selectedComponentIndex == i) {
          let salaryComponentObj = this.assignedComponentsObj;

          let obj = {
            salary_component_id: salaryComponentObj.id,
            applicable_from: salaryComponentObj.applicableFrom_date,
            applicable_to: salaryComponentObj.applicableTo_date,
            amount: salaryComponentObj.amount,
            name: salaryComponentObj.name,
            unassign_date: salaryComponentObj.unassign_date
              ? salaryComponentObj.unassign_date
              : null,
            advanced_setting: this.monthsArray,
            status: this.getStatus(salaryComponentObj)
          };

          finalArr.push(obj);
        } else {
          let salaryComponentObj = addedComponentsArr[i];

          let obj = {
            salary_component_id: salaryComponentObj.salary_component_id,
            applicable_from: salaryComponentObj.applicable_from,
            applicable_to: salaryComponentObj.applicable_to,
            amount: salaryComponentObj.amount,
            name: salaryComponentObj.name,
            unassign_date: salaryComponentObj.unassign_date
              ? salaryComponentObj.unassign_date
              : null,
            advanced_setting: salaryComponentObj.advanced_setting
              ? salaryComponentObj.advanced_setting
              : null,
            status: this.getStatus(salaryComponentObj)
          };

          finalArr.push(obj);
        }
      }

      try {
        let obj = {
          data: {
            employee_id: this.employeeObject.id,
            //financial_year:"2019-2020",
            legal_entity_id: this.le_id,
            salary_component: finalArr
          }
        };

        //console.log("performAction:", obj);

        let res = await this.updateNonCtcComponents(obj);
        //console.log("updateNonCtcComponents:", res);

        if (res.status == 200 || res.status == 201) {

            await this.act_updateRecordsComponentsAdvancedSettings({
              advanced_setting: this.monthsArray,
              index: this.selectedComponentIndex,
              assignedComponentsObj: this.assignedComponentsObj
          });

          this.cancel();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        //console.log("error:", err);
      }
    },

    refresh() {

      this.employeeObject =  null;

      this.selectedComponentIndex = null;
      this.componentsList = [];
      this.assignedComponentsObj = {
        componentObj: null,
        applicable_from: "",
        applicable_to: "",
        advanced_setting: null,
        amount: null,
        name: null,
        salary_component_id: null,
        unassign_date: null
      },


      this.monthsArray = [];
      this.componentObj = {};
      this.assignedComponentsList = [];

    }
  }
};
</script>

<style lang="scss" scoped>
.custom-grid {
  display: grid;
  grid-template-columns: 20% 20%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}

.margin-top-30 {
  margin-top: 30px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.card {
  display: flex;
  width: 25%;
  margin-right: 12px;
  height: 110px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-left: 20px;
}

.image {
  .alignImage {
    width: 100px;
    height: 100px;
    padding: 10px 0 0 10px;
  }
}

.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.emp-details {
  padding: 25px 0 0 10px;
  color: #535353;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.business {
  width: 100%;
  height: 100%;
}

.margin-left-20 {
  margin-left: 20px;
}

.datatable-outer-container {
  width: 100%;
  margin-bottom: 50px;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    //   table-layout: fixed;

    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
        //   text-align: center;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        // border-right: 1px solid #ececec;
        padding: 0 8px;
        // display: flex;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            //    display: block;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      //   text-align: center;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 6px 8px;
        color: #000000;
      }

      .action-img {
        display: block;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
      }
    }
  }
}

.custom-input {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  height: 35px;
  -webkit-transition: ease-in-out, width 0.35s ease-in-out;
  transition: ease-in-out, width 0.35s ease-in-out;
  :focus {
    border: 1px solid #34c0be;
  }
}
</style>
